<app-page-frame frameTitle="Course Composer" titleIcon="bi-magic" homeRoute="/course-composer">
    <router-outlet></router-outlet>
</app-page-frame>
